export default "__VITE_ASSET__BjSQuavo__"